import type { ThemeDefinition } from "../theme-definition.type";

export const teal: ThemeDefinition = {
  id: "teal",
  name: "Teal",
  light: {
    "background": "#f7fbfb",
    "foreground": "#0d1b1b",
    "card": "#ffffff",
    "muted": "#e7f3f2",
    "muted-foreground": "#536868",
    "border": "#d9e4e4",
    "input": "#878f8f",
    "primary": "#157171",
    "primary-foreground": "#ffffff",
    "accent": "#dcf4f4",
    "accent-foreground": "#003737",
    "brand": "#004648",
    "brand-foreground": "#ffffff",
    "ring": "#3c8f8f",
    "success": "#3a732c",
    "warning": "#875814",
    "destructive": "#ac2f2f",
    "info": "#296898",
    "popover": "#ffffff",
    "link": "#157171",
  },
  dark: {
    "background": "#141717",
    "foreground": "#edf1f1",
    "card": "#1d2121",
    "popover": "#252c2b",
    "muted": "#2b3232",
    "muted-foreground": "#acb3b2",
    "border": "#394343",
    "input": "#6b6e6e",
    "primary": "#008489",
    "primary-foreground": "#ffffff",
    "link": "#53d1d0",
    "accent": "#004040",
    "accent-foreground": "#bff0ef",
    "brand": "#003638",
    "brand-foreground": "#eef7f7",
    "ring": "#00afaf",
    "success": "#7fc76f",
    "warning": "#e6b55d",
    "destructive": "#f48780",
    "info": "#7db4e4",
  },
};

export const violet: ThemeDefinition = {
  id: "violet",
  name: "Violet",
  light: {
    "background": "#fafafd",
    "foreground": "#191721",
    "card": "#ffffff",
    "muted": "#f0eff8",
    "muted-foreground": "#646170",
    "border": "#e2e0e9",
    "input": "#8e8d93",
    "primary": "#675794",
    "primary-foreground": "#ffffff",
    "accent": "#efebff",
    "accent-foreground": "#31254e",
    "brand": "#3e256e",
    "brand-foreground": "#ffffff",
    "ring": "#8474b4",
    "success": "#3a732c",
    "warning": "#875814",
    "destructive": "#ac2f2f",
    "info": "#296898",
    "popover": "#ffffff",
    "link": "#675794",
  },
  dark: {
    "background": "#161618",
    "foreground": "#f0f0f3",
    "card": "#212023",
    "popover": "#2a292e",
    "muted": "#302f34",
    "muted-foreground": "#b1b0b6",
    "border": "#414047",
    "input": "#6d6d70",
    "primary": "#8c51f4",
    "primary-foreground": "#ffffff",
    "link": "#c0aaff",
    "accent": "#392c58",
    "accent-foreground": "#e7deff",
    "brand": "#2f1758",
    "brand-foreground": "#f5f4fb",
    "ring": "#9f86e1",
    "success": "#7fc76f",
    "warning": "#e6b55d",
    "destructive": "#f48780",
    "info": "#7db4e4",
  },
};
